export let isValidObject = (object, type = 'object') =>
  object && typeof object == type;

export let isValidString = (object) => isValidObject(object, 'string');

export let getObjectProperty = (object, property, default_value = '') =>
  isValidObject(object) && property in object
    ? object[property]
    : default_value;

export let textIncludes = (text, keyword) =>
  isValidString(text) && isValidString(keyword)
    ? text.toLowerCase().includes(keyword.toLowerCase())
    : false;

export let highlightKeyword = (text, keyword) => {
  if (isValidString(text) && isValidString(keyword) && keyword.length > 0) {
    let regExp = new RegExp(keyword, 'gi');
    return text.replace(
      regExp,
      (s) => `<span style='background-color:#def700ff'>${s}</span>`
    );
  }
  return text;
};

export let debounce = (func, wait, immediate) => {
  let timeout;

  return function executedFunction() {
    let context = this;
    let args = arguments;

    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

export let isOutOfViewport = (elem) => {
  const bounding = elem.getBoundingClientRect();
  const out = {};

  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight);
  out.right =
    bounding.right >
    (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;

  return out;
};
